import React, { createContext, useContext, useState } from "react";

export interface WorkspaceColors {
  primary_dark: string;
  secondary: string;
  accent: string;
}

const defaultColors: WorkspaceColors = {
  primary_dark: "#032e4d",
  secondary: "#054d7f",
  accent: "#f28d01",
};

const WorkspaceColorContext = createContext<{
  colors: WorkspaceColors;
  setColors: React.Dispatch<React.SetStateAction<WorkspaceColors>>;
}>({
  colors: defaultColors,
  setColors: () => {},
});

export const WorkspaceColorProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [colors, setColors] = useState<WorkspaceColors>(defaultColors);

  return (
    <WorkspaceColorContext.Provider value={{ colors, setColors }}>
      {children}
    </WorkspaceColorContext.Provider>
  );
};

export const useWorkspaceColors = () => useContext(WorkspaceColorContext);
